<template>
  <modal name="confirm-modal"
         @before-open="handleBeforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-3 position-relative bg-primary">
      <div class="w-100 d-flex">
        <h4 class="text-white"></h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('confirm-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body"
         class="d-flex justify-content-center align-items-center p-4"
         style="overflow-x: auto; height: 85%">
      <p class="h5" style="text-align: justify">
        Հարգելի գործընկեր
        <br/>
        <br/><span class="tab"/>iTender համակարգի տվյալ բաժինը ստեղծված է, որպեսզի գնորդ հանդիսացող այն կազմակերպությունները, որոնք իրենց գնումներն իրականացնում են տենդերների /մրցույթների/ միջոցով, կարողանան հրապարակեն իրենց տենդերները  iTender համակարգում։ 
        <br/><span class="tab"/>Այս գործիքը հնարավորություն է տալիս կազմակերպված տենդերների շրջանակներում ապահովելու ավելի շատ մասնակիցների, որպեսզի տենդերները լինեն ավելի մրցակցային և արդյունավետ։
        <br/><span class="tab"/>Հրապարակվող տենդերների հայտարարությունները պետք է հիմնված լինեն տենդերներները կանոնակարգող համապատասխան իրավական ակտի վրա, որտեղ հստակ սահմանված են կողմերի իրավունքներն ու պարտականությունները, հաղթողներին որոշելու կարգն ու ժամկետները և չկրեն ուղղակի հայտարարության բնույթ։ 
        <br/><span class="tab"/>Արգելվում է նաև կցել վիրուսակիր ֆայլեր, հրապարակել գովազդային, մարքեթինգային, քաղաքական, լրատվական, աշխատանքային և այլ հայտարարություններ և նյութեր, որոնք չեն համարվում տենդեր։ Նշված պայմաններին չհամապատասխանող հրապարակումները համակարգի ադմինիստրացիայի կողմից ենթակա են հեռացման։
        <br/><span class="tab"/>Բացի ձեր կազմակերպության տենդերների կանոնակարգերի հիման վրա տեդներներ կազմակերպելուց, կարող եք նաև տենդերներ կազմակերպել <span @click="() => this.$router.push('/organizator/itender')" style="cursor: pointer" class="btn-link">iTender համակարգի միջոցով</span>, որտեղ գնային առաջարկների ներկայացումը, հաղթողներին որոշելը իրականացվում են iTender համակարգի միջոցով։

      </p>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button @click="$modal.hide('confirm-modal')" class="btn btn-sm btn-light mr-3">
        {{ declineBtnText }}
      </button>
      <button @click="confirm" :disabled="loading" type="button" class="btn btn-sm btn-primary">
        <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ confirmBtnText }}
      </button>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'ConfirmModal',
    props: {
      confirmBtnText: {
        default: 'Հաստատել',
        type:  String
      },
      declineBtnText: {
        default: 'Չեղարկել',
        type: String
      }
    },
    data() {
      return {
        alertMsg: '',
        callback: null,
        loading: false
      }
    },
    methods: {
      handleBeforeOpen({ params }) {
        this.alertMsg = params.msg
        this.callback = params.callback
      },
      confirm() {
        this.loading = true;
        this.callback()
      }
    }
  }
</script>
<style>
    .tab {
        margin-left: 25px;
    }
</style>
<style scoped>
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    position: absolute;
    width: 40vw !important;
    height: 70vh !important;
    margin: auto;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>
